import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {OfficeCoupon} from 'src/app/classes/OfficeCoupon';
import {CouponStatus} from '../enums/CouponStatus';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class OfficeCouponsService {

  constructor(private httpClient: HttpClient) { }

  public getAll(status: CouponStatus): Observable<OfficeCoupon[]> {

    const options = status ? {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('status', status)
    } : httpOptions;

    return this.httpClient.get<OfficeCoupon[]>(`${environment.backendApiUrl}/v1/coupons`, options);
  }

  public addOrEdit(coupon: OfficeCoupon): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/coupons`, coupon, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/coupons/` + id, httpOptions);
  }

  public verifyByCode(code: string): Observable<OfficeCoupon> {
    return this.httpClient.get<OfficeCoupon>(`${environment.backendApiUrl}/v1/coupons/` + code + '/verify', httpOptions);
  }
}
